module.exports = __webpack_public_path__ + "img/img-teamwork-qrcode.6b033213.png";